import apiClient from './apiClient';
import { BASE_PATH } from '../constants/UriConstants';

const OTTER_AUTHORIZE_URL = `${BASE_PATH}otter/auth/authorize`;
const OTTER_CONNECTION_URL = `${BASE_PATH}otter/connection`;

export interface OtterAuthorizeUrlResponse {
  authorize_url: string;
}

export interface OtterSelectableStore {
  brandId: string;
  brandName: string;
  storeId: string;
  storeName: string;
}

export interface OtterConnectionStatus {
  connected: boolean;
  otterStoreId?: string;
}

export const getOtterAuthorizeUrl = (state?: string): Promise<OtterAuthorizeUrlResponse> =>
  apiClient.get(OTTER_AUTHORIZE_URL, { params: state ? { state } : undefined }).then(response => response.data);

export const getOtterConnectionStatus = (): Promise<OtterConnectionStatus> => apiClient.get(OTTER_CONNECTION_URL).then(response => response.data);

// Returns Otter's consent URL: deleting Otter's side of the connection needs a fresh authorization,
// and the backend finishes the disconnect when Otter redirects back with `?otterDisconnected=1`.
export const disconnectOtterStore = (): Promise<OtterAuthorizeUrlResponse> => apiClient.delete(OTTER_CONNECTION_URL).then(response => response.data);

// ─── Storefront Status / Pause / Unpause ─────────────────────────────────────

const OTTER_STOREFRONT_STATUS_URL = `${BASE_PATH}otter/storefront/status`;
const OTTER_STOREFRONT_PAUSE_URL = `${BASE_PATH}otter/storefront/pause`;
const OTTER_STOREFRONT_UNPAUSE_URL = `${BASE_PATH}otter/storefront/unpause`;

export interface OtterStorefrontStatus {
  isPaused: boolean;
}

interface OtterStorefrontStatusResponse {
  restaurantID: number;
  isAcceptingOrders: boolean;
  otterStoreId: string;
}

export const getOtterStorefrontStatus = (): Promise<OtterStorefrontStatus> =>
  apiClient.get<OtterStorefrontStatusResponse>(OTTER_STOREFRONT_STATUS_URL).then(({ data }) => ({
    isPaused: !data.isAcceptingOrders,
  }));

export const pauseOtterStorefront = (): Promise<void> => apiClient.post(OTTER_STOREFRONT_PAUSE_URL).then(() => undefined);

export const unpauseOtterStorefront = (): Promise<void> => apiClient.post(OTTER_STOREFRONT_UNPAUSE_URL).then(() => undefined);
